module.exports = {
  "id": "boulder",
  "title": "boulder",
  "image": "provision/parts/boulder/boulder.png",
  "info": [
    {
      "text": "Add a boulder to your project",
      "image": "provision/parts/boulder/boulder.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/boulder/boulder.png"
}
;